module.exports = (__webpack_require__(7389))("./src/index.js");